import './App.css';
import React, { useEffect, useState } from 'react';
import { auth } from './firebase';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Dashboard from './Components/Dashboard';
import Home from './Components/Home';
import AuctionsPage from './Components/Auction/AuctionsPage';
import Profile from './Components/Profile';
import AboutUs from './Components/AboutUs';
import HowItWorks from './Components/HowItWorks';
import CreateAuctionItem from './Components/Auction/CreateAuctionItem';
import AuctionItemView from './Components/Auction/AuctionItemView';
import Offices from './Components/Offices';
import Terms from './Components/Legal/Terms';
import TermsSeller from './Components/Legal/TermsSeller';
import Login from './Components/Login';
import Landing from './Components/Landing';
import Cancel from './Components/Payments/Cancel';
import PaySuccess from './Components/Payments/PaySuccess';
import Prohibited from './Components/Legal/Prohibited';
import PirvacyPolicy from './Components/Legal/PrivacyPolicy';
import RefundPolicy from './Components/Legal/RefundPolicy';
import EULA from './Components/Legal/EULA';
import ContactUs from './Components/Legal/ContactUs';

function App() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
      const unsubscribe = auth.onAuthStateChanged((currentUser) => {
          setUser(currentUser);
          // if (currentUser) {
          //   // Navigate to /home when user logs in
          //   navigate('/home');
          // }

      });

      return () => unsubscribe();
  }, []);

  

  return (
    <div className="App">
      <Routes>
        {/* Public Route */}
        <Route path="/login" element={<Login />} />

        {/* Private Routes */}
        <Route path="/" element={<Dashboard />}>
            <Route index element={<Home />} />
            <Route path="home" element={<Home />} />
            <Route path="auctions" element={<AuctionsPage />} />
            <Route path="profile" element={<Profile />} />
            <Route path="how-it-works" element={<HowItWorks />} />
            <Route path="about-us" element={<AboutUs />} />
            <Route path="create-auction" element={<CreateAuctionItem />} />
            <Route path="auctions/:id" element={<AuctionItemView />} />
            <Route path="offices" element={<Offices />} />
            <Route path="/eula" element={<EULA />} />
            <Route path="/terms-conditions" element={<Terms />} />
            <Route path="/terms-conditions-seller" element={<TermsSeller />} />
            <Route path="/privacy-policy" element={<PirvacyPolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/prohibited" element={<Prohibited />} />
            <Route path="contact" element={<ContactUs />} />
            <Route path="/cancel" element={<Cancel />} />
            <Route path="/fee-success" element={<PaySuccess />} />
            <Route path="/success-page" element={<PaySuccess />} />
            <Route path="/success" element={<PaySuccess />} />
            <Route path="/seller-terms-conditions" element={<TermsSeller />} />
        </Route>
    </Routes>
    </div>
  );
}

export default App;
